//
// import {EventSourcePolyfill} from "event-source-polyfill";
// import {getToken} from "@/utils/auth";
//
// const defaultOptions = {
//     retry: 5,
//     interval: 3 * 1000,
// };
//
// class SSEClient {
//     constructor(url, options = defaultOptions) {
//         this.url = url;
//         this.es = null;
//         this.options = options;
//         this.retry = options.retry;
//         this.timer = null;
//         this.isCompleted = false; // 请求完成的标志
//     }
//
//     // 打开连接时触发
//     _onOpen() {
//         if (this.isCompleted) return; // 如果已完成，不处理 open 事件
//         console.log("Server Sent Event connection established");
//     }
//
//     // 消息处理函数
//     _onMessage(handler) {
//         return (event) => {
//             if (this.isCompleted) return; // 如果已完成，不处理消息
//
//             this.retry = this.options.retry; // 重置重试次数
//
//             try {
//                 // 判断是否是结束标识 [DONE]
//                 if (event.data.includes("[DONE]")) {
//                     console.log("Received completion signal, stopping reconnection.");
//                     this.isCompleted = true;
//                     this.unsunscribe(); // 断开连接，停止重连
//                     return;
//                 }
//
//                 // 提取并存储 id
//                 const idMatch = event.data.match(/id:(\d+)/);
//                 if (idMatch) {
//                     const id = idMatch[1];
//                     console.log("Storing ID to localStorage:", id);
//                     if (localStorage.getItem("messageId") === '0') {
//                         localStorage.setItem("messageId", id); // 存储到 localStorage
//                     }
//                 }
//
//                 // 处理正常 JSON 数据
//                 if (event.data.indexOf("{") !== -1) {
//                     const payload = JSON.parse(event.data);
//                     console.log("Receiving data...", payload);
//
//                     // 调用自定义的处理方法
//                     if (typeof handler === "function") {
//                         handler(payload);
//                     }
//                 }
//             } catch (error) {
//                 console.error("Failed to parse payload from server", error);
//             }
//         };
//     }
//
//     // 错误处理和重连机制
//     _onError(type, handler) {
//         return (event) => {
//             if (this.isCompleted) return; // 如果已完成，不处理错误事件
//             // 输出错误详细信息
//             throw new Error("asdfasdfasdfas")
//             if (this.es) {
//                 this._removeAllEvent(type, handler); // 移除所有事件监听
//                 this.unsunscribe(); // 断开当前连接
//             }
//
//             // 如果还需要重连
//             if (this.retry > 0) {
//                 // 如果是 EventSource 被关闭了，则不重连
//                 if (event && event.target && event.target.readyState === EventSource.CLOSED) {
//                     console.log("EventSource closed, not retrying.");
//                     return;
//                 }
//
//                 this.timer = setTimeout(() => {
//                     this.subscribe(type, handler); // 重连
//                 }, this.options.interval);
//             } else {
//                 this.retry--; // 减少重试次数
//             }
//         };
//     }
//
//     // 移除所有事件监听
//     _removeAllEvent(type, handler) {
//         if (this.es) {
//             this.es.removeEventListener("open", this._onOpen);
//             this.es.removeEventListener(type, this._onMessage(handler));
//             this.es.removeEventListener("error", this._onError(type, handler));
//         }
//     }
//
//     // 订阅消息
//     subscribe(type, handler) {
//         if (this.isCompleted) return; // 如果已完成，不再订阅
//
//         this.es = new EventSourcePolyfill(this.url, {
//             heartbeatTimeout: 60 * 60 * 1000,
//             headers: {
//                 "X-Access-Token": getToken(),
//             },
//         });
//
//         this.es.addEventListener("open", this._onOpen.bind(this)); // 连接成功时触发
//         this.es.addEventListener(type, this._onMessage(handler)); // 接收到消息时触发
//         this.es.addEventListener("error", this._onError(type, handler)); // 出错时触发
//
//         // 连接关闭时，确保更新 isCompleted 标志
//         this.es.addEventListener("close", () => {
//             this.isCompleted = true; // 设置标志为已完成
//             this.unsunscribe(); // 断开连接
//         });
//     }
//
//     // 取消订阅
//     unsunscribe() {
//         if (this.es) {
//             this.es.close(); // 关闭连接
//             this.es = null;
//         }
//         if (this.timer) {
//             clearTimeout(this.timer); // 清除重连定时器
//         }
//     }
// }
//
// export default SSEClient;


import {EventSourcePolyfill} from "event-source-polyfill";
import {getToken} from "@/utils/auth";

const defaultOptions = {
    retry: 5,
    interval: 3 * 1000,
};

class SSEClient {
    constructor(url, options = defaultOptions) {
        this.url = url;
        this.es = null;
        this.options = options;
        this.retry = options.retry;
        this.timer = null;
        this.isCompleted = false;
        this.isPaused = false;
    }

    _onOpen() {
        if (this.isCompleted || this.isPaused) return;
        console.log("Server Sent Event connection established");
    }

    _onMessage(handler) {
        return (event) => {
            if (this.isCompleted || this.isPaused) return;
            this.retry = this.options.retry;

            try {
                if (event.data.includes("[DONE]")) {
                    console.log("Received completion signal, stopping connection.");
                    this.isCompleted = true;
                    this.stop();
                    return;
                }

                const idMatch = event.data.match(/id:(\d+)/);
                // const idMatch = event.data.match(/id:([^\s]+)/); // 匹配 id: 后的所有非空白字符
                if (idMatch) {
                    const id = idMatch[1];
                    console.log("Storing ID to localStorage:", id);
                    if (localStorage.getItem("messageId") === '0') {
                        localStorage.setItem("messageId", id);
                    }
                }

                if (event.data.indexOf("{") !== -1) {
                    const payload = JSON.parse(event.data);
                    console.log("Receiving data...", payload);
                    if (typeof handler === "function") {
                        handler(payload);
                    }
                }
            } catch (error) {
                console.error("Failed to parse payload from server", error);
            }
        };
    }

    _onError(type, handler) {
        return (event) => {
            if (this.isCompleted || this.isPaused) return;

            if (this.es) {
                this._removeAllEvent(type, handler);
                this.stop();
            }

            if (this.retry > 0) {
                if (event?.target?.readyState === EventSource.CLOSED) {
                    console.log("EventSource closed, not retrying.");
                    return;
                }
                this.timer = setTimeout(() => {
                    this.start(type, handler);
                }, this.options.interval);
                this.retry--;
            }
        };
    }

    _removeAllEvent(type, handler) {
        if (this.es) {
            this.es.removeEventListener("open", this._onOpen);
            this.es.removeEventListener(type, this._onMessage(handler));
            this.es.removeEventListener("error", this._onError(type, handler));
        }
    }

    start(type, handler) {
        if (this.isCompleted) return;
        this.isPaused = false;

        this.es = new EventSourcePolyfill(this.url, {
            heartbeatTimeout: 60 * 60 * 1000,
            headers: {
                "X-Access-Token": getToken(),
            },
        });

        this.es.addEventListener("open", this._onOpen.bind(this));
        this.es.addEventListener(type, this._onMessage(handler));
        this.es.addEventListener("error", this._onError(type, handler));
        this.es.addEventListener("close", () => {
            this.isCompleted = true;
            this.stop();
        });
    }

    stop() {
        if (this.es) {
            this.es.close();
            this.es = null;
        }
        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.retry = this.options.retry;
    }

    pause() {
        this.isPaused = true;
        this.stop();
    }

    resume(type, handler) {
        if (this.isPaused) {
            this.isPaused = false;
            this.start(type, handler);
        }
    }
}

export default SSEClient;